export const handleGridStyle = (demopage: number, sidebarSize: number, isHidePanel: number) => {
  if (isHidePanel) return '1fr';
  return `${demopage ? 0 : sidebarSize}px 1fr`;
};

export const sanitizePath = (str: string | undefined) => str?.replace(/\/\s*$/, '');
